import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1543d478")

_pushScopeId("data-v-1543d478")
const _hoisted_1 = { class: "discount-line" }
const _hoisted_2 = { class: "discount column-1" }
const _hoisted_3 = /*#__PURE__*/_createVNode("p", { class: "title" }, "Název promo akce", -1)
const _hoisted_4 = { class: "value" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "divider" }, null, -1)
const _hoisted_6 = {
  key: 0,
  class: "title"
}
const _hoisted_7 = {
  key: 1,
  class: "title"
}
const _hoisted_8 = { class: "discount column-2" }
const _hoisted_9 = /*#__PURE__*/_createVNode("p", { class: "title" }, "Jazyky", -1)
const _hoisted_10 = { class: "value" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "divider" }, null, -1)
const _hoisted_12 = {
  key: 0,
  class: "discount column-3"
}
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "divider" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "divider" }, null, -1)
const _hoisted_15 = {
  key: 1,
  class: "discount column-4"
}
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "divider" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "divider" }, null, -1)
const _hoisted_18 = {
  key: 0,
  class: "discount-line"
}
const _hoisted_19 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_20 = { class: "discount column-1" }
const _hoisted_21 = /*#__PURE__*/_createVNode("p", { class: "title" }, "Název", -1)
const _hoisted_22 = { class: "value" }
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { class: "divider" }, null, -1)
const _hoisted_24 = { class: "discount column-2" }
const _hoisted_25 = /*#__PURE__*/_createVNode("p", { class: "title" }, "Obrázek", -1)
const _hoisted_26 = { class: "value" }
const _hoisted_27 = {
  href: "{{ translate.page_image_url }}",
  target: "_blank"
}
const _hoisted_28 = /*#__PURE__*/_createVNode("div", { class: "divider" }, null, -1)
const _hoisted_29 = {
  key: 1,
  class: "discount-line"
}
const _hoisted_30 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_31 = { class: "discount column-1" }
const _hoisted_32 = /*#__PURE__*/_createVNode("p", { class: "title" }, "Text k promo akci", -1)
const _hoisted_33 = { class: "value" }
const _hoisted_34 = /*#__PURE__*/_createVNode("div", { class: "divider" }, null, -1)
const _hoisted_35 = {
  key: 2,
  class: "discount-line"
}
const _hoisted_36 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_37 = { class: "discount column-1" }
const _hoisted_38 = /*#__PURE__*/_createVNode("p", { class: "title" }, "Jak sleva funguje?", -1)
const _hoisted_39 = { class: "value" }
const _hoisted_40 = /*#__PURE__*/_createVNode("div", { class: "divider" }, null, -1)
const _hoisted_41 = {
  key: 3,
  class: "discount-line"
}
const _hoisted_42 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_43 = { class: "discount column-1" }
const _hoisted_44 = /*#__PURE__*/_createVNode("p", { class: "title" }, "Od kdy a do kdy sleva platí?", -1)
const _hoisted_45 = { class: "value" }
const _hoisted_46 = /*#__PURE__*/_createVNode("div", { class: "divider" }, null, -1)
const _hoisted_47 = {
  key: 4,
  class: "discount-line"
}
const _hoisted_48 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_49 = { class: "discount column-1" }
const _hoisted_50 = /*#__PURE__*/_createVNode("p", { class: "title" }, "Odkaz na web", -1)
const _hoisted_51 = { class: "value" }
const _hoisted_52 = /*#__PURE__*/_createVNode("div", { class: "divider" }, null, -1)
const _hoisted_53 = { key: 5 }
const _hoisted_54 = { key: 6 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode("p", _hoisted_4, _toDisplayString(_ctx.promoEvent.title), 1),
        _hoisted_5,
        (_ctx.visible === false)
          ? (_openBlock(), _createBlock("p", _hoisted_6, [
              _createVNode("a", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showDetail && _ctx.showDetail(...args))),
                class: "promo-event-detail"
              }, "Více informací")
            ]))
          : _createCommentVNode("", true),
        (_ctx.visible === true)
          ? (_openBlock(), _createBlock("p", _hoisted_7, [
              _createVNode("a", {
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showDetail && _ctx.showDetail(...args))),
                class: "promo-event-detail"
              }, "Méně informací")
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_8, [
        _hoisted_9,
        _createVNode("p", _hoisted_10, _toDisplayString(_ctx.getLanguages().toString().toUpperCase()), 1),
        _hoisted_11
      ]),
      (_ctx.isRearranging === false)
        ? (_openBlock(), _createBlock("div", _hoisted_12, [
            _createVNode("button", {
              class: "button-edit",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.editPromoEvent(_ctx.promoEvent)))
            }, "Upravit"),
            _hoisted_13,
            _createVNode("button", {
              class: "button-delete",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.removePromoEvent(_ctx.promoEvent)))
            }, "Smazat"),
            _hoisted_14
          ]))
        : _createCommentVNode("", true),
      (_ctx.isRearranging === true)
        ? (_openBlock(), _createBlock("div", _hoisted_15, [
            _createVNode("button", {
              class: "button",
              disabled: _ctx.promoEvent.order === 1,
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.movePromoEvent(_ctx.promoEvent, -1)))
            }, "Up", 8, ["disabled"]),
            _hoisted_16,
            _createVNode("button", {
              class: "button",
              disabled: _ctx.promoEvent.order === _ctx.listLength,
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.movePromoEvent(_ctx.promoEvent, 1)))
            }, "Down", 8, ["disabled"]),
            _hoisted_17
          ]))
        : _createCommentVNode("", true)
    ]),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getPromoEventTranslates(), (translate) => {
      return (_openBlock(), _createBlock("div", { key: translate }, [
        (_ctx.visible === true)
          ? (_openBlock(), _createBlock("div", _hoisted_18, [
              _hoisted_19,
              _createVNode("div", _hoisted_20, [
                _hoisted_21,
                _createVNode("p", _hoisted_22, _toDisplayString(translate.page_title), 1),
                _hoisted_23
              ]),
              _createVNode("div", _hoisted_24, [
                _hoisted_25,
                _createVNode("p", _hoisted_26, [
                  _createVNode("a", _hoisted_27, _toDisplayString(translate.page_image_url), 1)
                ]),
                _hoisted_28
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.visible === true)
          ? (_openBlock(), _createBlock("div", _hoisted_29, [
              _hoisted_30,
              _createVNode("div", _hoisted_31, [
                _hoisted_32,
                _createVNode("p", _hoisted_33, _toDisplayString(translate.page_content_description), 1),
                _hoisted_34
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.visible === true)
          ? (_openBlock(), _createBlock("div", _hoisted_35, [
              _hoisted_36,
              _createVNode("div", _hoisted_37, [
                _hoisted_38,
                _createVNode("p", _hoisted_39, _toDisplayString(translate.page_content_how_to_works), 1),
                _hoisted_40
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.visible === true)
          ? (_openBlock(), _createBlock("div", _hoisted_41, [
              _hoisted_42,
              _createVNode("div", _hoisted_43, [
                _hoisted_44,
                _createVNode("p", _hoisted_45, _toDisplayString(translate.page_content_date), 1),
                _hoisted_46
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.visible === true)
          ? (_openBlock(), _createBlock("div", _hoisted_47, [
              _hoisted_48,
              _createVNode("div", _hoisted_49, [
                _hoisted_50,
                _createVNode("p", _hoisted_51, _toDisplayString(translate.page_content_web), 1),
                _hoisted_52
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.visible === true)
          ? (_openBlock(), _createBlock("hr", _hoisted_53))
          : _createCommentVNode("", true),
        (_ctx.visible === true)
          ? (_openBlock(), _createBlock("br", _hoisted_54))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ], 64))
})